import { useThemeContext } from '#contexts/ThemeContext';
import { InfoHelperIcon } from '#images/icon';
import { PictureAnswerProps } from '#modules/PictureAnswer';
import { useAnswerStyles } from '#styles/imageAnswer';
import { Box, Checkbox, Paper, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { CheckOutlined, CloseOutlined } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import { colors } from '@swyft/ui';
import React from 'react';
import { ImageComponent } from './ImageComponent';

export const PictureOddAnswer = ({ answer, selected, multipleSelection }: PictureAnswerProps) => {
  const { iconColor, primaryButtonText, primaryButtonBackground, answerHelperText } = useThemeContext();
  const { getFixedSizeImage, getFontSize, answerBox, answerBoxSelected } = useStyles();
  const [isShowHelperText, setIsShowHelperText] = React.useState<boolean>(false);
  const classes = useAnswerStyles(isShowHelperText)();

  const handleClickIcon = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsShowHelperText(!isShowHelperText);
  };

  return (
    <Paper className={`${answerBox} ${selected ? answerBoxSelected : ''}`}>
      <Box position='relative' width='100%' display='flex' flexWrap='wrap'>
        <Box
          display='flex'
          padding={1}
          alignItems='center'
          width={answer.helperText ? 'calc(100% - 60px)' : '100%'}
          minHeight={{ xs: 60, sm: 80 }}
        >
          {multipleSelection && (
            <Box>
              <Checkbox
                color='primary'
                checked={selected}
                style={{ padding: '0px 0.625rem' }}
                className={classes.checkbox}
                checkedIcon={<CheckOutlined />}
              />
            </Box>
          )}
          <ImageComponent
            src={answer.imageUrl}
            color={iconColor}
            className={`${getFixedSizeImage}`}
            alt={answer.text}
          />
          <Box pl={2} width={`calc(100% - ${multipleSelection ? 100 : 60}px)`}>
            <Typography variant='subtitle2' className={classes.smallAnswerText}>
              {answer.text}
            </Typography>
          </Box>
        </Box>
        {answer.helperText && (
          <Box
            className={classes.helperAnswerWrapper}
            width={{ xs: 60 }}
            display='flex'
            justifyContent='center'
            alignItems='center'
            bgcolor={isShowHelperText ? primaryButtonBackground : 'unset'}
            onClick={(e) => handleClickIcon(e)}
          >
            {!isShowHelperText ? (
              <InfoHelperIcon className='helperIcon' />
            ) : (
              <CloseOutlined style={{ color: primaryButtonText }} />
            )}
          </Box>
        )}
        {answer.helperText && isShowHelperText && (
          <Box p={2} width={'100%'} borderTop={`1px solid ${colors.grey[50]}`}>
            <Typography variant='caption' style={{ color: answerHelperText }}>
              {answer.helperText}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

const useStyles = () => {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const { answerCardSelectedState, answerText, isTouchDevice } = useThemeContext();
  return makeStyles((theme: any) => ({
    getFixedSizeImage: {
      borderRadius: '0.25rem',
      objectFit: 'cover',
      [theme.breakpoints.up('xs')]: {
        width: 52,
        height: 52
      }
    },
    getFontSize: {
      fontSize: 14,
      color: answerText,
      fontWeight: 400,
      lineHeight: '18px'
    },
    answerBox: {
      width: '100%',
      outline: '1px solid transparent',
      cursor: 'pointer',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        outlineColor: isTouchDevice || isSmDown ? 'transparent' : answerCardSelectedState + '!important'
      }
    },
    answerBoxSelected: {
      outlineColor: answerCardSelectedState + '!important'
    }
  }))();
};
